import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "context/AuthProvider"; // Import useAuth

const AdminRoute = () => {
  const { user, loading } = useAuth(); // Get user & loading state

  if (loading)
    return <p className="text-center text-gray-500">Chargement...</p>;

  return user && user.master === true ? <Outlet /> : <Navigate to="/" />;
};

export default AdminRoute;
